<template>
	<div class="center_course_container">
		<div class="list_title">
			<div class="title">课程</div>
			<div class="tag">已购</div>
		</div>

		<div class="course_list" v-if="productData.list && productData.list.length>0">
			<div class="item" v-for="(item,index) in productData.list" @click="toDetail(item)">
				<img class="cover" src="../../assets/images/cover.png" v-if="item.img_url_tt==''" />
				<img class="cover" :src="item.img_url_tt" v-if="item.img_url_tt!=''" />
				<div class="info">
					<div class="title_box">
						<div class="title">{{item.title}}</div>
						<!-- <div class="author">主讲人：{{item.author}}</div> -->
					</div>
					<div class="exts_box">
						<div class="res_info">
							<div class="res_count">
								{{item.res_count}}小节
							</div>
							<div class="res_length">
								<i class="el-icon-pie-chart icon"></i>{{item.res_length}}
							</div>
						</div>

						<!-- <div class="price">已订阅</div> -->
						<div class="price">已学 {{item.learning_progress}}%</div>
					</div>
				</div>
			</div>
		</div>

		<div class="book_pager" v-if="productData.list && productData.list.length>0">
			<el-pagination @current-change="currentPage" :current-page.sync="search.page_index"
				:page-size="search.page_size" :pager-count="5" layout="prev, pager, next" :total="productData.total">
			</el-pagination>
			<div class="page_count">
				共 {{productData.count}} 页
			</div>
		</div>

		<div class="empty_box" v-if="productData.list && productData.list.length==0">
			<img class="empty_icon" src="../../assets/images/empty.png" />
			<div class="empty_texts" @click="toList()">
				<span class="empty_text" >您尚未加入任何课程</span>
				<span class="empty_link">去看看有哪些课程</span>
			</div>
		</div>

	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";


	export default {
		data() {
			return {
				search: {
					page_index: 1,
					page_size: 6,
					order_by: 'created_at:desc'
				},
				productData: {
					total: 0,
					count: 0,
					list: null,
				}
			};
		},
		created() {
			document.title = "机工教师特训营";
			this.getProductList();
		},
		methods: {
			toList() {
				this.GoToChangeTab(4);
			},
			toDetail(item) {
				this.GoToDetail(item.product_type, item.id);
			},
			getProductList() {
				var that = this;
				var url = apiUrl.tt_purchase_course_list_get;
				this.Ajax(url, this.search, (data, code, msg) => {

					if (that.productData.total == 0) {
						that.productData.total = data.total;
					}
					if (that.productData.count == 0) {
						that.productData.count = data.count;
					}
					that.productData.list = data.list;
					//console.log('productData' + JSON.stringify(that.productData))
					if (code == 40004 && that.search.page_index == 1) {
						that.productData.list = [];
					}
				});
			},
			currentPage(index) {
				this.search.page_index = parseInt(index);
				this.getProductList();
			}

		},
	};
</script>

<style lang="scss" scoped>
	.center_course_container {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #fff;
		
		.empty_box {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		
			.empty_icon {
				width: 220px;
				height: auto;
			}
		
			.empty_texts {
				display: flex;
				flex-direction: column;
				color: #C0C4CC;
				line-height: 1;
				cursor: pointer;
		
				.empty_text {
					font-size: 15px;
					margin-bottom: 10px;
				}
		
				.empty_link {
					font-size: 17px;
					border-bottom: 1px solid #C0C4CC;
					padding-bottom: 2px;
				}
			}
		}

		/deep/.book_pager {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: 40px;

			.page_count {
				display: inline-flex;
				height: 40px;
				justify-content: center;
				align-items: center;
				font-size: 16px;
				color: #959595;
			}

			.el-pagination {
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.el-pagination .el-icon {
				font-size: 22px !important;
				cursor: pointer;
			}


			.el-pager li {
				font-size: 16px !important;
				display: inline-flex;
				width: 40px !important;
				min-width: 40px !important;
				height: 40px !important;
				align-items: center;
				justify-content: center;
				background-color: #fff;
				border-radius: 50%;
				font-weight: 400;
				color: #959595;
				margin: 5px;
				cursor: pointer;
			}


			.el-pager li.active {
				background-color: #F3641E !important;
				color: #fff !important;

			}
		}

		.list_title {
			display: flex;
			align-items: flex-end;

			.title {
				font-size: 17px;
				margin-right: 15px;
			}

			.tag {
				font-size: 12px;
				color: #FBA559;
				margin-bottom: 3px;
			}
		}

		.course_list {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			margin-top: 20px;

			.item {
				width: 280px;
				height: 265px;
				margin-right: 20px;
				margin-bottom: 40px;
				cursor: pointer;
				overflow: hidden;
				display: flex;
				flex-direction: column;
				border-radius: 20px;

				&:nth-child(3n+3) {
					margin-right: 0;
				}

				&:hover {
					box-shadow: -1px 2px 5px 0 rgba(0, 0, 0, 0.1);
					border-radius: 20px;
				}

				.cover {
					width: 100%;
				}

				.info {
					flex: 1;
					background-color: #F1F1F1;
					display: flex;
					flex-direction: column;

					.title_box {
						flex: 1;
						display: flex;
						flex-direction: column;
						padding: 15px 10px 10px 15px;

						.title {
							font-size: 20px;
							font-weight: 600;
							line-height: 1.2;
						}

						.author {
							font-size: 18px;
							line-height: 1;
							margin-top: 8px;
						}
					}

					.exts_box {
						width: 100%;
						height: 40px;
						border-radius: 0 0 20px 20px;
						border-top: 1px solid #E8E8E8;
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 0 17px 0 20px;
						box-sizing: border-box;

						.res_info {
							display: flex;
							font-size: 13px;
							align-items: center;

							.res_count {
								background-color: #c93a2e;
								color: #fff;
								padding: 2px 8px;
								border-radius: 20px;
							}

							.res_length {
								margin-left: 8px;

								.icon {
									margin-right: 2px;
								}
							}
						}

						.price {
							font-weight: 600;
							font-size: 17px;
							color: #c93a2e;
						}
					}

				}
			}
		}

	}
</style>